import script from "./UserPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPerfil.vue?vue&type=script&setup=true&lang=js"

import "./UserPerfil.vue?vue&type=style&index=0&id=363fa470&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363fa470"]])

export default __exports__